<template>
    <div fluid class="fill">
      <div v-if="!useModalView && !groupModal">
        <div class="d-none d-md-block d-lg-block d-sm-none">
          <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
            <b-nav>
              <b-nav-item disabled>Action:</b-nav-item>
              <b-nav-item @click="updateMessageView(composeSMS)"><i class="icons icon-speech"></i> Favorite</b-nav-item>
            </b-nav>
            <!-- Right aligned nav items -->
            <b-nav class="ml-auto">
              <b-button variant="primary" @click="showAddGroupModal"><i class="icon-bubbles icons d-block"> New</i></b-button>
            </b-nav>
          </b-navbar>
        </div>
        <b-row class="margin-0">
            <b-col lg="5" md="12" class="bg-light padding-0">
              <b-navbar toggleable="md" class="bottom-border padding-0" type="light" variant="white">
                <b-nav style="padding-top: 10px !important;">
                  <b-nav-item class="tab-button nav-item-black active"
                  ><i class="icon-list icons font-1xl d-sm-down-none"></i> Template Groups ({{templateGroups.length}})</b-nav-item>
                </b-nav>
                <!-- Right aligned nav items -->
                <b-nav class="ml-auto">
                  <b-nav-item-dropdown text="Sort by" right>
                    <template slot="button-content">
                        <i class="py-0 fa fa-filter"></i> 
                        <em class="d-sm-down-none"> Filter </em>
                    </template>
                    <b-dropdown-item href="#">Name</b-dropdown-item>
                  </b-nav-item-dropdown>
                </b-nav>
              </b-navbar>
              <div class="border-0">
                  <div class="email-app border-0">
                      <main class="inbox border-0 padding-0">
                        <keep-alive>
                          <component
                              :is="GroupList"
                              :groups="templateGroups"
                              @show-template-group-view="showGroupView"
                          ></component>
                        </keep-alive>
                      </main>
                  </div>
              </div>
            </b-col>
            <b-col lg="7" md="0" class="pane-border d-md-down-none padding-0">
                <keep-alive v-if="!useModalView">
                <component
                    :is="groupComponent"
                    :group="selectedGroup"
                    :total="templateGroups.length"
                    @all-template-group-selections="allTemplateGroupSelections"
                    @template-group-edit="showEditGroupModal"
                ></component>
              </keep-alive>
            </b-col>
        </b-row>
      <vue-fab
      class="d-sm-block d-md-none d-lg-none "
      :mainBtnColor="mainBtnColor"
      :icon="mainBtnIcon">
        <fab-item 
            v-for="(item, idx) in menu"
            :idx="idx"
            :key="idx"
            :title="item.title"
            :color="item.color"
            :icon="item.icon"
            @clickItem="clickItem(item.link)"/>
      </vue-fab>
    </div>
    <div v-else>
      <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
          <b-nav>
              <b-nav-item @click="useModalView = groupModal = false"><i class="icon-arrow-left icons"></i></b-nav-item>
              <b-nav-item disabled> Back</b-nav-item>
              <!--b-nav-item><i class="cui-speech icons"></i> Free SMS</b-nav-item>
              <b-nav-item><i class="cui-comment-square icons"></i> Campaign SMS</b-nav-item-->
            </b-nav>
            <!-- Right aligned nav items -->
            <!--b-nav class="ml-auto">
              <b-nav-item><i class="icons icon-wallet"></i> Units Balance: {{Number(user.units_balance).toLocaleString()}}</b-nav-item>
            </b-nav-->
        </b-navbar>

        <!--keep-alive-->
          <component v-if="useModalView"
            :is="groupComponent"
            :group="selectedGroup"
            :total="templateGroups.length"
            @template-group-edit="showEditGroupModal"
            @all-template-group-selections="allTemplateGroupSelections"
            :isDialog="false"
          ></component>
        <!--/keep-alive-->

        <b-card class="m-2 mr-3" v-if="groupModal">
            <p>{{modalTitle}}</p>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <input type="text" v-model="name" class="form-control" id="cc" placeholder="Enter name">
            </b-col>
          </div>
          <div class="aside-options pb-3">
            <div class="clearfix mt-4">
              <small><b>Private group?</b></small>
              <c-switch class="float-right" color="primary" v-model="isPrivate" label dataOn="yes" dataOff="no"/>
            </div>
            <div>
              <small class="text-muted">This is to indicate if you want other members of Zigatext community to see it or not.</small>
            </div>
          </div>

          <b-button class="mt-3" variant="primary" block @click="handleAction">

          <span v-if="!loading">{{actionText}}</span>
              <div class="sk-circle" v-if="loading">
                  <div class="sk-circle1 sk-child"></div>
                  <div class="sk-circle2 sk-child"></div>
                  <div class="sk-circle3 sk-child"></div>
                  <div class="sk-circle4 sk-child"></div>
                  <div class="sk-circle5 sk-child"></div>
                  <div class="sk-circle6 sk-child"></div>
                  <div class="sk-circle7 sk-child"></div>
                  <div class="sk-circle8 sk-child"></div>
                  <div class="sk-circle9 sk-child"></div>
                  <div class="sk-circle10 sk-child"></div>
                  <div class="sk-circle11 sk-child"></div>
                  <div class="sk-circle12 sk-child"></div>
              </div>
              <i v-if="flashSendError" class="fa fa-times"></i>
          </b-button>
        </b-card>
    </div>
  </div>
</template>

<script>

import Vue from "vue"
import { mapState, mapActions } from "vuex"
import GroupList from '@/components/sms-collections/GroupList'
import groupView from '@/components/sms-collections/GroupView'
import {} from '@/services/notification.service'
import groupAction from '@/components/sms-collections/GroupAction'
import {EventBus} from '@/events/bus.event'
import router from '@/router/index'
import { Switch as cSwitch } from '@coreui/vue'

export default {
  name: 'SMSCollections',
  components: {
    GroupList,
    groupView,
    groupAction,
    cSwitch,
  },
  data () {
    return {
      selectedTemplateGroup: null,
      deliveryTime: Vue.moment().format(),
      groupModal: false,
      selectedGroup: null,
      GroupList: GroupList,
      groupView: groupView,
      groupComponent: groupAction,
      isPrivate: false,
      groupAction: groupAction,
      name: '',
      actionText: 'Create',
      modalTitle: 'Create template group',
      editing: false,
      description: '',
      flashSendError : false,
      useModalView: false,
      screenBreakPoint: 975,
      menu: [
          {
            icon: 'icons icon-speech',
            title: 'Favorite',
            color: '#c2185b',
            link: '/newsletter'
          },
          {
            icon: 'icon-bubbles icons',
            title: 'Create Group',
            color: '#c2185b',
            link: 'popup'
          }
        ],
      mainBtnColor: '#c2185b',
      mainBtnIcon: 'icon-menu icons',
    }
  },
  computed: {
    ...mapState('smsCollection', ['templateGroups', 'loading', 'serverResponse']),
    ...mapState('user', ['user']),
  },
  created() {
    if (this.templateGroups.length <= 0) {
      this.fetchSMSCollections({page:1})
    }
  },
  notifications: {
    showCreateSuccess: {
      title: 'Success',
      message: 'Your sms collection has been created!',
      type: 'success'
    },
    showCreateFailed: {
      title: 'Failed',
      message: 'SMS collection could not be created at this time!',
      type: 'error'
    },
    showNotificationError: {
      title: 'Failed',
      message: 'Name field is required!',
      type: 'error'
    },
    showDeleteError: {
      title: 'Failed',
      message: 'There was error deleting these sms collections',
      type: 'error'
    },
    showDeleteSuccess: {
      title: 'Success',
      message: 'SMS collection(s) deleted successfully',
      type: 'success'
    },
    showUpdateSuccess: {
      title: 'Success',
      message: 'SMS collection updated!',
      type: 'success'
    },
    showUpdateFailed: {
      title: 'Failed',
      message: 'SMS collection could not be updated at this time!',
      type: 'error'
    },
  },

  methods: {
    ...mapActions('smsCollection', [
        'fetchSMSCollections', 'fetchGroupTemplates', 'createGroup'
    ]),

    handleLoadGroups: function() {
      if(this.nextPage <= this.pages && !this.loading)
        this.fetchGroups({page:this.nextPage})
    },
    
    handleResize () {
      this.useModalView = window.innerWidth < this.screenBreakPoint
    },

    showGroupView(e) {
      this.useModalView = window.innerWidth <= this.screenBreakPoint

      if(e.templates.length === 0)
        this.fetchGroupTemplates({groupId:e.id, page:e.templates_next_page})

      this.selectedGroup = e
      this.groupComponent = this.groupView
    },

    handleLoadContacts: function () {
      if(this.selectedGroup.contacts_next_page <= this.selectedGroup.contact_pages && !this.loading)
        this.fetchGroupTemplates({groupId:this.selectedGroup.id, page:this.selectedGroup.contacts_next_page})
    },

    showOnDialog () {
      return this.useModalView
    },

    handleDeleteGroup() {
      if (this.loading) {
        this.$swal('You have already clicked delete button')
        return
      }

      this.$swal({
        title: "Delete birthday group",
        text: "Sure you want to delete this birthday group?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => { 
        if (result.value) {
          this.deleteSelectedGroups()
        }
      })
    },

    showAddGroupModal: function() {
      this.name = ''
      this.description = ''
      this.selectedTemplateGroup = null
      this.deliveryTime = Vue.moment().format()
      this.actionText = 'Create'
      this.modalTitle = 'Create template group'
      this.editing = false
      this.groupModal = true
    },

    showEditGroupModal: function() {
      this.name = this.selectedGroup.name
      this.description = this.selectedGroup.description
      this.selectedTemplateGroup = null


      this.actionText = 'Update'
      this.modalTitle = 'Update template group'
      this.editing = true
      this.groupModal = true
    },

    formatTime: function(date) {      
      return date.substr(11, 5)
    },

    async handleAction() {

      if(this.loading)
        return

      if(this.name == '')  {
        this.showNotificationError()
        return
      }

      const requestData = {
        "name"           : this.name,
        "personal"       : this.isPrivate,
      }
      
      if (this.editing) {
        let status = await this.updateGroup({ data: requestData, id: this.selectedGroup.id }) 
        if( !status ) {
          this.groupModal = false
          this.showUpdateFailed({message: this.serverResponse.message})
        } else {
          this.groupModal = false
          this.showUpdateSuccess()
        }
      } else {
        let status = await this.createGroup({ data: requestData})
        if( !status ) {
          this.actionText = ''
          this.flashSendError = true
          this.showCreateFailed({message: this.serverResponse.message})

          let interval = setInterval(() => {
            this.actionText = 'Create'
            this.flashSendError = false
            clearInterval(interval)
          }, 1000)
        } else {
          this.groupModal = true
          this.showCreateSuccess()
        }
      }
    },
    clickItem: function (link) {
      if (link == 'popup') {
        this.showAddGroupModal()
        return
      }
      //router.push(link)
    },

    allTemplateGroupSelections: function (flag) {
      this.groupComponent = groupAction
    },
  }
} 
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style type="text/css" scoped>
    .tab-content {
        border: 0 !important;
    }

  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }
</style>